import React, { createContext, useContext, useEffect,  useState } from "react";
import { ConfigContext } from "../security/ConfigContext";
import LoadingSpinner from "../components/common/LoadingSpinner";
import useSecurity from "../hooks/useSecurity";
import _ from "lodash";
import { Action } from "./DashboardContext";
import UserUtils from "../utils/UserUtils";
import useAxios from "../adapter/useAxios";
import {UserContext} from "./UserContext";
import { useHistory } from "react-router-dom";
import { SocketContext } from "./SocketContext";
import SocketUtils from "../utils/SocketUtils";


const initialState = {
  selectAlll: false,
  loading: true,
  showLoading: () => {},
  request: {},
  updateRecordsR: (_action: Action, _recordIds, _data, qcCallback?: () => void, _qcValidated: boolean = false, _isExternal: boolean = false, _isWorkflowCancelled: boolean = false , 
  _isHoldFlow: boolean = false) => {},
  selectedColumnActionR: {},
  _setColumnActionR: (_action) => {},
  updateNotesRequestSummary: (_recordId, _data) => {},
  _setSelectAll: (_valus) => {},
  job: {},
  resetJob: () => {}
};

let requestId = "";

export const RequestSummaryContext = createContext(initialState);
RequestSummaryContext.displayName = "RequestSummaryContext";

export const RequestSummaryProvider = ({ children }) => {
  const [config] = useContext(ConfigContext);
  const [loading, setLoading] = useState(initialState.loading);
  const [selectAlll, setSelectAll] = useState(initialState.selectAlll);
  const [request, setRequest] = useState(initialState.request);
  const [job, setJob] = useState(initialState.job);
  const { isAuthenticated, getAccessToken, userInfo } = useSecurity();
  const [selectedColumnActionR, setColumnAction] = useState(initialState.selectedColumnActionR);
  const {get, put} = useAxios();
  const { userRole,isUserLoading } = useContext(UserContext);
  const history = useHistory();
  const { _setMessageToSocket, messageFromSocket, _setMessageFromSocket } = useContext(SocketContext)
  const updateRequestSocketMessage = SocketUtils.buildSocketMessage('REQUEST_SUMMARY');
  let user = UserUtils.transformUserInfo(userInfo, true);

  const _setColumnActionR = (action) => {
    setColumnAction(action);
  };

  const updateNotesRequestSummary = (recordId, data) => {
    if (_.isEmpty(recordId)) {
      return;
    }
    put({
      url: config.apiUrls.jobs + _.first(recordId) + "/notes",
      data: data
    })
    .then(() => {
      refreshRequestSummary();
    })
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      setLoading(false);
    })
  };

  const _setSelectAll = (value) => {
    setSelectAll(value);
    if (!value) {
      setColumnAction({
        event: null,
        action: null,
        icon: null,
        id: null,
        selected: null,
      });
    }
  };

  const refreshRequestSummary = () => {
      user = UserUtils.transformUserInfo(userInfo);
    get({
      url: config.apiUrls.requests + requestId,
      signal: true
    })
    .then((response) => {
      if (UserUtils.isJobTypeAccessible(userRole, _.get(response, "jobType"))) {
        setRequest(response);
      } else {
        history.push("/");
      }
    })
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      setLoading(false);
    })
  };

  useEffect(() => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      requestId = urlParams.get("id");
     if (isAuthenticated) {
        refreshRequestSummary();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, getAccessToken]);

  useEffect(() => {
    if(messageFromSocket && SocketUtils.isDashboardAndSummaryRefresh(messageFromSocket)) {
      console.log('Refreshed Request summary page...');
      refreshRequestSummary();
      _setMessageFromSocket("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageFromSocket]);

  const showLoading = () => {
    setLoading(true);
  };

  const resetJob = () => {
    setJob({});
  };


  const updateRecordsR = (action: Action, recordIds, data, qcCallback?, qcValidated: boolean = false, isExternal: boolean = false, isWorkflowCancelled: boolean = false , 
    isHoldFlow: boolean = false) => {    
    if (_.isEmpty(recordIds) || _.isEmpty(action) || _.isEmpty(data)) {
      return;
    }
    let isMultiple = _.size(recordIds) > 1 && _.isArray(recordIds) ? true : false;
    let requestUrl = isMultiple ? config.apiUrls.jobs + "updateMultiple" : config.apiUrls.jobs + recordIds;

    if (isMultiple) {
      data["id"] = recordIds;
    }
    data["user"] = user;
    setLoading(true);
    if (isExternal) {
      return put({
        url: config.apiUrls.jobs + recordIds + "/status",
        data:  data
      })
      .then(() => {
        refreshRequestSummary();
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false);
      }) 
    } else if (isWorkflowCancelled || isHoldFlow) {
      let automationUrl = config.apiUrls.jobs + recordIds + "/status";
      const automationCall = () => {
        return put({
          url: automationUrl,
          data: {
            status: isHoldFlow ? "hold" : "cancel",
            user: user
          }
        })
        .then(() => {
          refreshRequestSummary()
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setLoading(false);
        })
      };
      automationCall();
    } else {
      if (action === Action.STATUS || action === Action.ASSIGNEE || action === Action.BEGINQC || action === Action.QCDONE || action === Action.RESUMEWORKFLOW || action === Action.DUEDATE) {
        if (action === Action.QCDONE && qcValidated) {
          data["status"] = "WF_QC_DONE";
        }
        return put({
          url: requestUrl,
          data: data
        })
        .then((response) => {
          if (qcCallback) {
            qcCallback();
            setJob(response[0] ? response[0] : response);
          } 
          _setMessageToSocket(updateRequestSocketMessage);
        })
        .catch((error) => {
          console.log(error)
        }) 
        .finally(() => {
          setLoading(false);
        })
      }
    }
  };

  return (
    <RequestSummaryContext.Provider
      value={{
        loading,
        selectAlll,
        showLoading,
        _setSelectAll,
        request,
        updateRecordsR,
        _setColumnActionR,
        selectedColumnActionR,
        updateNotesRequestSummary,
        job,
        resetJob
      }}>
      {children}
      <LoadingSpinner show={loading || isUserLoading} />
    </RequestSummaryContext.Provider>
  );
};
